export const UPLOAD_FILES = 'UPLOAD_FILES'
export const FILE_WAS_UPLOADED = 'FILE_WAS_UPLOADED'
export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR'
export const FILES_UPLOAD_RESET = 'FILES_UPLOAD_RESET'
